import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]

import { useCameraFrameStore, useLayoutStore } from '@/store'
import { storeToRefs } from 'pinia'


export default /*@__PURE__*/_defineComponent({
  __name: 'TryOnCameraFrame',
  setup(__props) {

const layoutStore = useLayoutStore()
const cameraFrameStore = useCameraFrameStore()
const { tryOnInstance, tryOnUrl, isTryOnCameraReady } =
  storeToRefs(cameraFrameStore)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tryon-camera-frame", {
      ready: _unref(isTryOnCameraReady)
    }]),
    style: _normalizeStyle(`--scale-progress:${_unref(layoutStore).drawerState?.progress || 0}`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["tryon-camera-frame-scaler", { 'transition-by-css': _unref(layoutStore).drawerState?.transitingByCSS }])
    }, [
      (_unref(tryOnUrl))
        ? (_openBlock(), _createElementBlock("iframe", {
            ref_key: "tryOnInstance",
            ref: tryOnInstance,
            class: "iframe",
            src: _unref(tryOnUrl),
            key: _unref(tryOnUrl),
            allow: "camera",
            border: "0"
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ], 2)
  ], 6))
}
}

})